import React, { useState, useEffect } from "react";
import FullScreenLoadingView from "presentational/common/FullScreenLoadingView";
import Service from "lib/service-amp";
import { getEssentialUrl } from "lib/urlQueryParser";
import { withStore } from "store/storeHandler";
import { useHistory } from "react-router-dom";

function LogOutContainer(props) {
  const {
    needLogOut,
    cognitoTokenRefreshError,
    tokenAuthType,
    AppErrorActions,
    BookmarkActions,
    CognitoAuthActions,
    FollowingsOutfitActions,
    FollowUserListActions,
    GalleryActions,
    GoogleAnalyticsActions,
    ItemDetailActions,
    LoungeActions,
    MyAccountActions,
    MyItemActions,
    MyOutfitActions,
    OthersOutfitForGuestActions,
    OthersOutfitForUserActions,
    OutfitDetailActions,
    PickActions,
    SearchActions,
    SearchForLoungeActions,
    UserDeviceActions,
    UserProfileActions
  } = props;
  const [isGoogleLogoutInProgress, setIsGoogleLogoutInProgress] =
    useState(false);

  const history = useHistory();

  useEffect(() => {
    checkLogOut();
  });

  const checkLogOut = () => {
    checkNeedLogOut();
    checkTokenRefreshError();
  };

  const resetPrivateStore = () => {
    MyAccountActions.setLogOut();
    MyOutfitActions.deleteAllData();
    OthersOutfitForGuestActions.deleteAllData();
    OthersOutfitForUserActions.deleteAllData();
    FollowingsOutfitActions.deleteAllData();
    BookmarkActions.deleteAllData();
    SearchActions.deleteAllData();
    MyItemActions.deleteAllData();
    UserProfileActions.deleteAllData();
    OutfitDetailActions.deleteAllData();
    PickActions.deleteAllData();
    FollowUserListActions.deleteAllData();
    GalleryActions.deleteAllData();
    CognitoAuthActions.deleteAllData();
    AppErrorActions.deleteAllData();
    LoungeActions.deleteAllData();
    SearchForLoungeActions.deleteAllData();
    ItemDetailActions.deleteAllData();
  };

  const normalLogOut = async () => {
    await Service.logOut();
    resetPrivateStore();
    if (tokenAuthType !== "google") {
      history.push(getEssentialUrl({ type: "opening" })());
    } else {
      /**
       * 일반 코드처럼 수행하면 루트화면으로 이동후 다시 redirect 되느라 화면 깜빡임
       * 깜빡임 이전에 사용자가 취한 액션은 다시 무효로 되므로 애초에 내가 리다이렉트를 안시킴
       * 리다이렉트 안시켰더니 로그아웃 완료상황이 살짝 보이고 구글리다이렉트 되기에,
       * 화면 아예 가려버림.
       */
      setIsGoogleLogoutInProgress(true);
    }

    GoogleAnalyticsActions.removeUserInfoForGA();
    GoogleAnalyticsActions.startAnalyzingNewUser();
    try {
      UserDeviceActions.editViewerLocation();
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const allDeviceLogOut = () => {
    const promise = Service.logOutForAllDevice();
    promise.then(({ code, res }) => {
      if (code === "error") {
        AppErrorActions.setSafeAppError(Error(res));
      }
    });

    resetPrivateStore();
    history.push(getEssentialUrl({ type: "opening" })());

    GoogleAnalyticsActions.removeUserInfoForGA();
    GoogleAnalyticsActions.startAnalyzingNewUser();
    try {
      UserDeviceActions.editViewerLocation();
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const checkNeedLogOut = () => {
    switch (needLogOut) {
      case "normalLogOut":
        normalLogOut();
        break;
      case "allDeviceLogOut":
        allDeviceLogOut();
        break;
      default:
        break;
    }
  };

  const checkTokenRefreshError = () => {
    if (cognitoTokenRefreshError) {
      normalLogOut();
    }
  };

  return (
    <div>
      {isGoogleLogoutInProgress && (
        <FullScreenLoadingView useOpaqueBackground />
      )}
    </div>
  );
}

export default withStore({
  stateMap: {
    myAccount: ["needLogOut"],
    cognitoAuth: ["cognitoTokenRefreshError", "tokenAuthType"]
  },
  dispatchMap: [
    "myAccount",
    "myOutfit",
    "othersOutfitForGuest",
    "othersOutfitForUser",
    "followingsOutfit",
    "bookmark",
    "search",
    "myItem",
    "userProfile",
    "outfitDetail",
    "pick",
    "followUserList",
    "gallery",
    "cognitoAuth",
    "appError",
    "googleAnalytics",
    "lounge",
    "userDevice",
    "searchForLounge",
    "itemDetail"
  ]
})(LogOutContainer);
